import React, { useContext, useEffect, useState } from 'react';
import { FaList, FaEnvelope, FaCheckCircle } from 'react-icons/fa';
import axios from 'axios';
import AppContext from '../../../context/AppContext';
import CusNotiCard from '../../../components/customer/CustomerNotifications/CusNotiCard';

const TABS = [
  { key: 'all', label: 'All', icon: FaList, color: '#2C5F7C' },
  { key: 'unread', label: 'Unread', icon: FaEnvelope, color: '#FFB800' },
  { key: 'read', label: 'Read', icon: FaCheckCircle, color: '#28A745' },
];

const CusNotiList = () => {
  const { authToken, baseUrl, customerId, notifications, setnotification } = useContext(AppContext);

  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState('');
  const [activeTab, setActiveTab] = useState('all');

  useEffect(() => {
    setLoading(true);
    setFetchError('');

    axios
      .get(`${baseUrl}/customer/view-customer-notifications`, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((res) => {
        if (res.data.success) setnotification(res.data.data || []);
      })
      .catch((err) => {
        console.error('Notifications fetch error:', err);
        setFetchError('Failed to load notifications. Please try again.');
      })
      .finally(() => setLoading(false));
  }, [authToken, baseUrl, setnotification]);

  const handleMarkRead = (id) => {
    axios
      .post(
        `${baseUrl}/customer/mark-read`,
        { id },
        { headers: { Authorization: `Bearer ${authToken}` } }
      )
      .then(() => {
        setnotification((prev) =>
          prev.map((n) => (n.id === id ? { ...n, status: 'read' } : n))
        );
      })
      .catch((err) => console.error('Mark read error:', err));
  };

  const handleDelete = (id) => {
    axios
      .delete(`${baseUrl}/customer/delete-noti`, {
        headers: { Authorization: `Bearer ${authToken}` },
        data: { id },
      })
      .then(() => {
        setnotification((prev) => prev.filter((n) => n.id !== id));
      })
      .catch((err) => console.error('Delete notification error:', err));
  };

  const filtered =
    activeTab === 'all'
      ? notifications
      : notifications.filter((n) => n.status === activeTab);

  const counts = {
    all: notifications.length,
    unread: notifications.filter((n) => n.status === 'unread').length,
    read: notifications.filter((n) => n.status === 'read').length,
  };

  return (
    <>
      {/* Filter tabs */}
      <div className="cus-noti-tabs">
        {TABS.map(({ key, label, icon: Icon, color }) => (
          <button
            key={key}
            className={`cus-noti-tab ${activeTab === key ? 'active' : ''}`}
            onClick={() => setActiveTab(key)}
            style={activeTab === key ? { borderColor: color } : {}}
          >
            <Icon />
            <span>{label}</span>
            <span className="cus-noti-tab-count">{counts[key]}</span>
          </button>
        ))}
      </div>

      {/* List */}
      {loading ? (
        <div className="cus-noti-loading">
          <div className="cus-noti-spinner" />
          <p>Loading notifications…</p>
        </div>
      ) : fetchError ? (
        <div className="cus-noti-error">{fetchError}</div>
      ) : filtered.length === 0 ? (
        <div className="cus-noti-empty">
          <div className="cus-noti-empty-emoji">📭</div>
          <h3>
            {activeTab === 'unread'
              ? 'No unread notifications'
              : activeTab === 'read'
              ? 'No read notifications'
              : 'No notifications yet'}
          </h3>
          <p>{activeTab === 'unread' ? "You're all caught up!" : 'Nothing to show here.'}</p>
        </div>
      ) : (
        <div className="cus-noti-list">
          {filtered.map((n) => (
            <CusNotiCard key={n.id} notification={n} onMarkRead={handleMarkRead} onDelete={handleDelete} />
          ))}
        </div>
      )}
    </>
  );
};

export default CusNotiList;